import * as React from 'react';
import {SVGSource} from '@shopify/images';
import * as icons from './icons';

export type IconType = keyof typeof icons | '';

type ButtonType = JSX.IntrinsicElements['button']['type'];
type SVGElementProps = JSX.IntrinsicElements['svg'];
type ButtonElementProps = JSX.IntrinsicElements['button'];
type ComposedProps = SVGElementProps & ButtonElementProps;

export interface IconProps extends ComposedProps {
  icon?: IconType;
  sourceSVG?: SVGSource;
  size?: number;
  fill?: string;
  alt?: string;
  style?: React.CSSProperties;

  // When true will wrap svg with button and all implicit props will be passed to wrapper button instead of svg
  asButton?: boolean;
  buttonType?: ButtonType;
}

export function Icon({
  icon = '',
  sourceSVG,
  size = 12,
  fill,
  alt = '',
  style: propsStyle = {},
  asButton = false,
  buttonType = 'button',
  ...restProps
}: IconProps) {
  const IconSource = sourceSVG || icons[icon] || {};
  const style = {...propsStyle};

  if (fill) {
    style.color = fill;
  }

  const svgProps = {
    fill,
    style,
    width: size,
    height: size,
    'aria-label': alt,
  };

  /* eslint-disable react/button-has-type */
  return asButton ? (
    <button type={buttonType} {...restProps}>
      <IconSource {...svgProps} aria-hidden />
    </button>
  ) : (
    <IconSource {...svgProps} {...restProps} />
  );
  /* eslint-enable react/button-has-type */
}

export default Icon;
